import { IsArray, Values } from "@pdfking/tfunc"

import { is_element } from "./is_element"
import { is_function } from "./is_function"
import { is_iterator } from "./is_iterator"
import { is_null } from "./is_null"
import { is_object } from "./is_object"

const _to_array = iterable => {
  if (IsArray(iterable)) {
    return iterable
  }
  if (is_iterator(iterable)) {
    const array = []
    for (let value of iterable) {
      array.push(value)
    }
    return array
  }
  if (is_function(iterable) || is_element(iterable)) {
    return [iterable]
  }
  if (is_object(iterable)) {
    return Values(iterable)
  }
  if (is_null(iterable)) {
    return []
  }
  return [iterable]
}

export const to_array = (...args) => {
  if (args.length == 1) {
    return _to_array(args[0])
  }
  return _to_array(args).reduce((a, b) => a.concat(_to_array(b)), [])
}
